import { money, unmoney } from './functions.js';

export default function MoneyInputModule(element) {

    let round = element.getAttribute('kd-round') || false;

    function formatField() {
        let value = parseFloat(unmoney(element.value));

        if (isNaN(value)) {
            value = 0;
        }
        
        let decimals = round ? 0 : 2;
        let formatted = money(value, decimals);

        element.value = formatted;
    }
    element.addEventListener('blur', function() {
        formatField();
    });

    element.addEventListener('focus', function() {
        element.value = unmoney(element.value);
        element.setSelectionRange(0, element.value.length)
    });

    formatField();

    return this;
}